import { Component, OnInit, HostListener } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Account } from 'src/app/models/account';
import { AccountService } from 'src/app/services/account.service';
import { TouchSequence } from 'selenium-webdriver';
import { Router, NavigationEnd, Event } from '@angular/router';
import { BasketService } from 'src/app/services/basket.service';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})

export class MenuComponent implements OnInit {
  public loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public account: any = new Account;
  public accountName = '';
  public practiceImage:string='';
  public practiceName:string='';
  public practiceDisabled=0;
  public activeMenu = null;
  public basketItems: number = 0;
  public mobileMenuActive:boolean = false;
  public notifications;
  public limited:boolean=false;
  public verify:boolean=false;
  // TimeZone related configuration
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;
  public AucklandTimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;
  public UAETimeZone:boolean = false;
  // Country selector
  public selectedCountry: string = '';
  public countryDropdownOpen: boolean = false;
  public countries = [
    { code: 'AU', label: 'Australia',   flagIcon: 'fi-au' },
    { code: 'CA', label: 'Canada',      flagIcon: 'fi-ca' },
    { code: 'HK', label: 'Hong Kong',   flagIcon: 'fi-hk' },
    { code: 'EU', label: 'Europe',       flagIcon: 'fi-eu' },
    { code: 'NZ', label: 'New Zealand', flagIcon: 'fi-nz' },
    { code: 'AE', label: 'UAE',         flagIcon: 'fi-ae' },
    { code: 'UK', label: 'UK',          flagIcon: 'fi-gb' },
    { code: 'US', label: 'USA',         flagIcon: 'fi-us' },
  ];

  get selectedCountryObj() {
    return this.countries.find(c => c.code === this.selectedCountry) || this.countries.find(c => c.code === 'UK') || this.countries[0];
  }

  constructor(
      private authService: AuthenticationService,
      private accountService: AccountService,
      private router: Router,
      private basketService: BasketService,
      private timezoneService: TimeZoneService
      ) {
    if(localStorage.getItem('limitedPractice') && localStorage.getItem('limitedPractice') == '1') this.limited=true;
    this.loggedIn=this.authService.loggedIn;
    this.practiceImage=localStorage.getItem('practiceImage');
    this.practiceName=localStorage.getItem('practiceName');
    this.practiceDisabled=parseInt(localStorage.getItem('practiceDisabled'));
    this.selectedCountry = this.timezoneService.getSelectedCountry() || 'UK';
    this.loggedIn.subscribe(loggedIn=>{
      if(loggedIn){
        this.account=this.accountService.getLocalAccount();
        this.accountName=(this.account.first_name.charAt(0)+this.account.last_name.charAt(0)).toUpperCase();
        this.practiceImage=localStorage.getItem('practiceImage');
        this.practiceName=localStorage.getItem('practiceName');
        this.practiceDisabled=parseInt(localStorage.getItem('practiceDisabled'));
      } else {
        this.practiceImage='';
        this.practiceName='';
      }
      this.notifications={'none':true};
      if (window.location.href.indexOf("/account/verify-email") > -1) {
        this.verify = true;
      }
      this.accountService.notificationsChanged.subscribe(event=>{
        this.checkNotifications();
      });
      this.accountService.practiceChanged.subscribe(event=>{
        this.practiceImage=localStorage.getItem('practiceImage');
        this.practiceName=localStorage.getItem('practiceName');
        this.practiceDisabled=parseInt(localStorage.getItem('practiceDisabled'));
      });

    });

    this.accountService.accountChanged.subscribe(event=>{
      this.checkNotifications();
    });

    this.basketService.basket.subscribe(res=>{
      this.basketItems = res.items.length;
    })
  }

  @HostListener('document:click')
  closeDropdown() {
    this.countryDropdownOpen = false;
  }

  showMobileMenu(){
    this.mobileMenuActive = true;
  }
  toggleAccountMenu(){
    if(!this.activeMenu){
      this.activeMenu = 'account'
    }
    else{
      this.activeMenu = null;
    }
  }

  hideMenus(){
    this.activeMenu=null;
    this.mobileMenuActive = false;
  }

  checkNotifications(){
    if(!this.account.id) return;
    if(localStorage.getItem('notifications')) {
      this.notifications=JSON.parse(localStorage.getItem('notifications'));
    } else {
      this.notifications={'none':true};
    }
  }

  changeCountry(event: any) {
    const code = event.target.value;
    this.timezoneService.setCountryLocalOnly(code);
    if (this.loggedIn.getValue()) {
      this.accountService.saveCountryPreference(code).subscribe(
        () => window.location.reload(),
        () => window.location.reload()
      );
    } else {
      window.location.reload();
    }
  }

  toggleCountryDropdown(event: any) {
    event.stopPropagation();
    this.countryDropdownOpen = !this.countryDropdownOpen;
  }

  selectCountry(country: any, event: any) {
    event.stopPropagation();
    this.timezoneService.setCountryLocalOnly(country.code);
    if (this.loggedIn.getValue()) {
      this.accountService.saveCountryPreference(country.code).subscribe(
        () => window.location.reload(),
        () => window.location.reload()
      );
    } else {
      window.location.reload();
    }
  }

  ngOnInit() {
    // Check the timeZone
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    this.UAETimeZone = this.timezoneService.checkUAETimeZone();
  }

  logout(){
    this.hideMenus();
    this.practiceImage='';
    this.authService.logout();
  }

  goTo(location){
    this.hideMenus();

    this.router.navigate([location]);
  }
}

